/**
 * Phone-width / reduced-motion enter: skip opacity 0 so route changes
 * do not flash a transparent frame before the destination paints.
 */
export function wwwRouteEnter(skipMotion, y = 16) {
  return skipMotion ? false : { opacity: 0, y };
}
